import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { TemplateNavigationItem } from '@app/layout/sidebar/models/template-navigation-item.model'
import { Tag } from 'primeng/tag'

@Component({
  selector: 'albert-list-view-template-list-item',
  standalone: true,
  imports: [
    RouterLinkActive,
    RouterLink,
    Tag
  ],
  templateUrl: './list-view-template-list-item.html',
  styleUrl: './list-view-template-list-item.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListViewTemplateListItem {
  public readonly itemClicked = output()
  public readonly item = input.required<TemplateNavigationItem>()

  public onEntryClick(): void {
    this.itemClicked.emit()
  }
}
